import { Link } from "react-router-dom";
import logo from '../assets/logo.png'
import '../styles/navbar.css'
import { useState } from "react";

const Navbar = () => {

    let[menu , setMenu] = useState(false);

    let scrollup = ()=>{
        window.scroll({
            top: 0, 
            left: 0, 
           });
    }
    
    return ( <nav>
                <div className="logo">
                    <Link to="/"><img src={logo} alt="" onClick={scrollup} /></Link>
                </div>

                <div className="nav-links">
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/about">About us</Link></li>
                        <li><Link to="/facilities">Facilities</Link></li>
                        <li><Link to="/academics">Academics</Link></li>
                        <li><Link to="/admission">Admission</Link></li>
                        <li><Link to="/contact">Contact us</Link></li>
                        <li><Link to="/gallery">Gallery</Link></li>
                    </ul>
                </div>

                <div className="hamberger-menu">
                    <button onClick={()=>{setMenu(!menu)}}><i className='bx bx-menu'></i></button>
                    {menu && <ul>
                        <li onClick={()=>{setMenu(false); scrollup();}}><Link to="/">Home</Link></li>
                        <li onClick={()=>{setMenu(false); scrollup();}}><Link to="/about">About us</Link></li>
                        <li onClick={()=>{setMenu(false); scrollup();}}><Link to="/facilities">Facilities</Link></li>
                        <li onClick={()=>{setMenu(false); scrollup();}}><Link to="/academics">Academics</Link></li>
                        <li onClick={()=>{setMenu(false); scrollup();}}><Link to="/admission">Admission</Link></li>
                        <li onClick={()=>{setMenu(false); scrollup();}}><Link to="/contact">Contact us</Link></li>
                        <li onClick={()=>{setMenu(false); scrollup();}}><Link to="/gallery">Gallery</Link></li>
                    </ul>}
                </div>


            </nav> );
}
 
export default Navbar;